import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DashboardRoutingModule } from './dashboard-routing.module';
import { DashboardComponent } from './dashboard.component';
import { ContentComponent } from './components/content/content.component';
import { SvgModule } from 'src/app/modules/svg/svg.module';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { SwitchButtonModule } from 'src/app/modules/switch-button/switch-button.module';
import { TranslationModule } from 'src/app/i18n/translation.module';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { LangSwitcherDashboardModule } from 'src/app/modules/lang-switcher-dashboard/lang-switcher-dashboard.module';
import { ModalModule } from 'src/app/modules/modal/modal.module';
import { DirectivesModule } from 'src/app/modules/directives/directives.module';

@NgModule({
  declarations: [
    DashboardComponent,
    // all down will be removed
    ContentComponent,
    BreadcrumbComponent,
  ],
  imports: [
    CommonModule,
    DashboardRoutingModule,
    LangSwitcherDashboardModule,
    ModalModule,
    // all down will be removed..
    SvgModule,
    SwitchButtonModule,
    TranslationModule,
    LazyLoadImageModule,
    DirectivesModule
  ]
})
export class DashboardModule { }
